import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import ThemeToggle from '@/components/ThemeToggle'; 
import UserMenu from '@/components/header/UserMenu';
import NavItem from '@/components/header/NavItem';
import MobileSheet from '@/components/header/MobileSheet';
import NotificationHandler from '@/components/header/NotificationHandler';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import NavOverflowMenu from '@/components/header/NavOverflowMenu';

const HeaderCore = ({ appName, filteredNavLinks, user, t, isSheetOpen, setIsSheetOpen, isLanguageReady }) => {
  if (!isLanguageReady) {
    return (
      <div className="container flex justify-between items-center h-16 animate-pulse">
        <div className="w-24 h-6 rounded bg-muted"></div>
        <div className="hidden items-center space-x-1 md:flex lg:space-x-2">
          {[...Array(5)].map((_, i) => <div key={i} className="w-20 h-6 rounded bg-muted"></div>)}
        </div>
        <div className="flex items-center space-x-1 md:space-x-2">
          <div className="w-8 h-8 rounded-full bg-muted"></div>
          <div className="w-8 h-8 rounded-full bg-muted"></div>
        </div>
      </div>
    );
  }

  // Desktop-only: hide Learn Hub and Mentors to reduce crowding when user is logged in
  // When user is not logged in, show these items directly in the header
  const desktopHiddenPaths = new Set(['/learn', '/mentors']);
  const desktopLinks = user 
    ? filteredNavLinks.filter(link => !desktopHiddenPaths.has(link.path))
    : filteredNavLinks; // Show all available links when not logged in
  const desktopHiddenLinks = user 
    ? filteredNavLinks.filter(link => desktopHiddenPaths.has(link.path))
    : []; // No hidden links when not logged in

  return (
    <div className="container flex justify-between items-center h-16">
              <Link to="/" className="flex items-center" onClick={() => setIsSheetOpen(false)}>
          <img 
            src="/assets/logo_Logo.png" 
            alt={`${appName} logo`} 
            className="w-auto h-12"
          />
        </Link>

      <nav className="hidden items-center space-x-1 md:flex lg:space-x-2">
        {desktopLinks.map(link => (
          <NavItem key={link.path} name={link.name} path={link.path} icon={link.icon} />
        ))}
        {user && <NavOverflowMenu links={desktopHiddenLinks} />}
      </nav>

      <div className="flex items-center space-x-2 md:space-x-3">
        <LanguageSwitcher />
        {user && <NotificationHandler />}
        {user ? (
          <UserMenu />
        ) : (
          <div className="hidden items-center space-x-2 md:flex">
            <Button variant="ghost" asChild>
              <Link to="/login">{t('common.login')}</Link>
            </Button>
            <Button asChild>
              <Link to="/register">{t('common.register')}</Link>
            </Button>
          </div>
        )}
        <div className="md:hidden">
          <MobileSheet
            appName={appName}
            logoUrl={null}
            filteredNavLinks={filteredNavLinks}
            user={user}
            t={t}
            isLanguageReady={isLanguageReady}
            isSheetOpen={isSheetOpen}
            setIsSheetOpen={setIsSheetOpen}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderCore;
  
